import {gsap} from "gsap";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {FireInTheHole2} from "../../FireInTheHole2";
import {APISetting} from "@nolimit/slot-launcher/bin/interfaces/APISettingsSystem";


export class FreespinSpinPresentation implements SimplePresentation {
    name: string = "TopTrainSpinPresentation";

    constructor() {
    }

    shouldRun(): boolean {
        return true;
    }

    start(controller: SimplePresentationRunnerController): void {
        const tl = gsap.timeline();
        tl.add(() => controller.setSkipCallback(() =>{
            tl.timeScale(3);
        }));
        tl.add(FireInTheHole2.freespinReelArea.spin());
        tl.add(() => controller.finish());

        if (FireInTheHole2.apiPlugin.settings.get(APISetting.FAST_SPIN)){
            tl.timeScale(1.4);
        }
    }
}